<template>
  <div class="Authentication-login">
    <transition>
      <div
        v-if="serverValidationErrors.fail"
        class="Notice Notice--danger"
      >
        <div class="Notice-copy">
          {{ serverValidationErrors.fail }}
        </div>
      </div>
    </transition>

    <form
      ref="login"
      class="Form"
      data-rmpdev-selector="login-form"
    >
      <form-input
        v-model="fields.email"
        :error="validateStatus({ field: v$.fields.email, serverKey: 'email', label: 'Email' })"
        :manual-validate="validateAll"
        has-icon
        icon="far fa-envelope Icon--left"
        label="Email"
        input-type="email"
        placeholder="Enter your email address"
        required
        data-cy-id="email-field"
        @change="validateBlur({ field: v$.fields.email, serverKey: 'email' })"
      />

      <form-input
        v-model="fields.password"
        :error="validateStatus({ field: v$.fields.password, serverKey: 'password', label: 'Password' })"
        :manual-validate="validateAll"
        label="Password"
        has-icon
        icon="far fa-lock Icon--left"
        input-type="password"
        placeholder="Enter your password"
        data-cy-id="password-field"
        @change="validateBlur({ field: v$.fields.password, serverKey: 'password' })"
      />
      <p class="forgotten-password-styled">
        <a href="/forgotten-password">Forgotten your password?</a>
      </p>

      <button
        :class="['Button Button--primary Button--long', {'is-loading' : ui.loading}]"
        data-cy-id="login-button"
        @click.prevent="loginSubmit"
      >
        Log in
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, email } from '@vuelidate/validators';
import FormInput from '@/components/form/input';
import ValidationMixin from '@/mixins/validation-mixin';
import useVuelidate from '@vuelidate/core';

export default {
  components: {
    FormInput,
  },
  mixins: [ValidationMixin],
  props: {
    noRedirect: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      fields: {
        email: null,
        password: null,
      },
      validationStatus: false,
      validationErrors: {},
      error: false,
      registrationTags: [],
      ui: {
        loading: false,
      },
      validateAll: false,
      serverValidationErrors: {},
    };
  },
  validations() {
    const rules = {
      fields: {
        email: {
          required, email,
        },
        password: {
          required,
        },
      },
    };
    return rules;
  },
  computed: {
    ...mapState('user', {
      isLoggedIn: (state) => state.loggedIn,
    }),
  },

  methods: {
    ...mapActions('user', {
      login: 'logInUser',
    }),

    loginSubmit() {
      console.log('login submit');
      this.validateAll = true;
      this.ui.loading = true;

      this.v$.$validate();

      if (this.v$.fields.$invalid) {
        this.ui.loading = false;
        this.$emit('login-form:validation-error');
        return false;
      }
      const payload = {
        email: this.fields.email,
        password: this.fields.password,
      };

      const urlRef = window.location.search.replace('?ref=', '');

      const pageRef = window.__RMP_REVIEWS_REF__ || ''; // eslint-disable-line

      if (urlRef.length || pageRef.length) {
        payload.ref = urlRef || pageRef;
      }

      this.ui.loading = true;
      this.serverValidationErrors = [];

      return this.login(payload)
        .then((response) => {
          const { ref } = response.data.data;

          this.ui.loading = false;
          this.$emit('login-form:success', { redirectUrl: ref });
        })
        .catch((error) => {
          this.ui.loading = false;
          if (error.data.meta.length > 0) {
            error.data.meta.forEach((validationField) => {
              this.serverValidationErrors[validationField.field] = validationField.message;
            });
          }

          if (error.data.data.message) {
            this.serverValidationErrors.fail = error.data.data.message;
          }
          this.$emit('login-form:error');
        });
    },
  },
};
</script>

<style scoped lang="scss">
  @import "../../../../scss/abstracts/abstracts.scss";

  .Authentication {
    background: color('white');
    padding: spacing(lg);
    border-radius: radius();
    box-shadow: 0 2px 8px 0px rgba(0,0,0,.17);
    max-width: 530px;
    margin: spacing(lg) auto spacing(lg) auto;
    @include respond-to(md){
      /*padding: spacing(xl);*/
    }
  }

  .LoginForm {
    margin-bottom: spacing();
  }
</style>
